import React from 'react';
import PropTypes from 'prop-types';

const SearchListItemSubTitle = props => (
  <p className="afd-search-list__subtitle">{props.subtitle}</p>
);

SearchListItemSubTitle.propTypes = {
  subtitle: PropTypes.string.isRequired,
};

export default SearchListItemSubTitle;
